import { ReactNode } from "react";

import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";

import { ApiKeyViewRoleBinding } from "../../types";
import ApiKeyRolesBulkActionsSelectedItem from "./SelectedRoleItem";
import ApiKeyRolesBulkActionsConfirmActionForm from "./ConfirmActionForm";
import { ApiKeyRolesBulkActionsAnalyticsPayload, ApiKeyRolesBulkActionsSelectedAction } from "./types";
import { ApiKeyRolesMutationVariables } from "./useApiKeyRolesBulkActions/types";

type ApiKeyRolesBulkActionsConfirmationViewProps = {
  applicableItems: ApiKeyViewRoleBinding[];
  skippedItems: ApiKeyViewRoleBinding[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: ApiKeyRolesBulkActionsSelectedAction;
  onConfirm: (
    mutationVariables: ApiKeyRolesMutationVariables,
    analyticsPayload: ApiKeyRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const ApiKeyRolesBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: ApiKeyRolesBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <ApiKeyRolesBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <ApiKeyRolesBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
          customConfirmationMessage={customConfirmationMessage}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default ApiKeyRolesBulkActionsConfirmationView;